/* /pages/before-and-afters-v2: filtros do topo (Collections / Products / Cup Size + RESET) = porte do before-after-v3.js
   DELE, com as classes que o prep renomeou (active -> clx-active, disabled -> clx-disabled).
   Retrabalho 10-09 (operador): SEM paginacao -> so a "pagina 1" (os 12 primeiros resultados do filtro atual). */
(function () {
  var PER = 12, ACT = 'clx-active', DIS = 'clx-disabled';
  var inserts = ['ultra-boost-inserts®', 'ultra-boost-lite-inserts', 'demi-boost-inserts®', 'demi-boost-lite-inserts', 'invisible-lift-inserts®', 'subtle-lift-inserts', 'micro-lift-inserts-2-pairs', 'ultra-boost-bundle'];
  var bras = ['magic-padded-sticky-bra', 'boomba®-sticky-bra', 'demi-sticky-bra', 'boomba-invisibra®'];
  var tapes = ['body-tape', 'reusable-body-tape', 'magic-breast-lift'];
  var PROD = { 'ultra-boost': 'ultra-boost-inserts®', 'ultra-boost-lite': 'ultra-boost-lite-inserts', 'demi-boost': 'demi-boost-inserts®',
    'demi-boost-lite-inserts': 'demi-boost-lite-inserts', 'invisible-lift': 'invisible-lift-inserts®', 'subtle-lift-inserts': 'subtle-lift-inserts',
    'micro-lift-inserts': 'micro-lift-inserts-2-pairs', 'magic-padded-sticky-bra': 'magic-padded-sticky-bra', 'boomba-sticky-bra': 'boomba®-sticky-bra',
    'demi-sticky-bra': 'demi-sticky-bra', 'boomba-invisibra': 'boomba-invisibra®', 'body-tape': 'body-tape', 'reusable-body-tape': 'reusable-body-tape',
    'magic-breast-lift': 'magic-breast-lift', 'ultra-boost-bundle': 'ultra-boost-bundle' };
  var CAT = { 'adhesive-inserts': ['all-products', 'all-inserts', 'ultra-boost', 'ultra-boost-lite', 'demi-boost', 'demi-boost-lite-inserts', 'invisible-lift', 'subtle-lift-inserts', 'micro-lift-inserts'],
    'adhesive-bras': ['all-products', 'all-bras', 'magic-padded-sticky-bra', 'boomba-sticky-bra', 'demi-sticky-bra', 'boomba-invisibra'],
    'body-tapes': ['all-products', 'all-tapes', 'body-tape', 'reusable-body-tape', 'magic-breast-lift'] };
  function init() {
    var root = document.querySelector('.before-after');
    if (!root || root.__cl) return; root.__cl = 1;
    var $$ = function (s, r) { return [].slice.call((r || root).querySelectorAll(s)); };
    var items = $$('.content-sizing-area__result-item');
    var pDrop = root.querySelector('.dropdown-list[data-select="products"]');
    if (!pDrop) return;
    var pBox = pDrop.closest('.custom-select'), pSel = pBox.querySelector('.selected');
    var allP = pBox.querySelector('li[data-value="all-products"]');
    var allPText = allP ? allP.querySelector('.option-title').innerText : 'All Products';
    var sel = { collections: null, products: null, cups: null };
    var pag = document.getElementById('pagination-container'); if (pag) pag.remove();
    function showPage() {
      var vis = items.filter(function (i) { return !i.classList.contains('hide'); });
      items.forEach(function (i) { i.style.display = 'none'; });
      vis.slice(0, PER).forEach(function (i) { i.style.display = 'block'; });
    }
    function match(item, ignoreCups, allCollWithProduct) {
      var c = item.getAttribute('data-category'), s = item.getAttribute('data-size'), col = sel.collections, p = sel.products, show = true;
      if (col === 'adhesive-inserts') show = inserts.indexOf(c) > -1;
      else if (col === 'body-tapes') show = tapes.indexOf(c) > -1;
      else if (col === 'adhesive-bras') show = bras.indexOf(c) > -1;
      if (show && p && col !== 'all-collections' && PROD[p]) show = c === PROD[p];
      if (allCollWithProduct && col === 'all-collections' && p) show = true;
      if (!ignoreCups && show && sel.cups && sel.cups !== 'all') show = s === sel.cups;
      return show;
    }
    function updateCups() {
      var sizes = {};
      items.forEach(function (i) { if (match(i, true, true)) sizes[i.getAttribute('data-size')] = 1; });
      $$('.dropdown-list[data-select="cups"] li').forEach(function (li) {
        var v = li.getAttribute('data-value');
        var ok = v === 'all' || sizes[v];
        li.classList.toggle(DIS, !ok); li.style.pointerEvents = ok ? '' : 'none'; li.style.opacity = ok ? '1' : '0.5';
        if (v !== 'all') li.style.color = ok ? '#222' : '#d4d4d4';
      });
    }
    function apply() {
      var any = false;
      updateCups();
      items.forEach(function (i) {
        var ok = match(i, false, false);
        i.classList.toggle('hide', !ok); i.classList.toggle('selected', ok); if (ok) any = true;
      });
      var nr = root.querySelector('.no-results-message'); if (nr) nr.style.display = any ? 'none' : 'block';
      showPage();
    }
    function resetProducts() {
      sel.products = null; pSel.innerHTML = '<span>' + allPText + '</span>';
      $$('li', pBox).forEach(function (li) { li.classList.remove(ACT); var r = li.querySelector('.radio-circle'); r && r.classList.remove(ACT); });
      if (allP) { allP.classList.add(ACT); var r = allP.querySelector('.radio-circle'); r && r.classList.add(ACT); }
    }
    function lockProducts(lock) {
      pBox.classList.toggle(DIS, lock); pSel.style.pointerEvents = lock ? 'none' : '';
      if (lock) resetProducts();
      apply();
    }
    $$('.custom-select').forEach(function (box) {
      var s = box.querySelector('.selected');
      s.addEventListener('click', function () {
        if (box.classList.contains(DIS)) return;
        $$('.custom-select').forEach(function (o) { if (o !== box) o.classList.remove('open'); });
        box.classList.toggle('open');
      });
      ['collections', 'products', 'cups'].forEach(function (type) {
        var dd = box.querySelector('.dropdown-list[data-select="' + type + '"]');
        if (!dd) return;
        $$('li', dd).forEach(function (li) {
          li.addEventListener('click', function () {
            if (li.classList.contains(DIS)) return;
            var v = li.getAttribute('data-value'), t = (li.querySelector('.option-title') || {}).innerText || '';
            sel[type] = v;
            if (type === 'collections') {
              lockProducts(v === 'all-collections');
              var all = [].concat(CAT['adhesive-inserts'], CAT['adhesive-bras'], CAT['body-tapes']), valid = CAT[v] || all;
              $$('li', pDrop).forEach(function (pi) { pi.classList.toggle('hide', valid.indexOf(pi.getAttribute('data-value')) < 0); });
            }
            $$('li', box).forEach(function (o) { o.classList.remove(ACT); var r = o.querySelector('.radio-circle'); r && r.classList.remove(ACT); });
            li.classList.add(ACT); var r = li.querySelector('.radio-circle'); r && r.classList.add(ACT);
            s.innerHTML = '<span>' + t + '</span>';
            apply();
            box.classList.remove('open');
          });
        });
      });
    });
    document.addEventListener('click', function (e) { $$('.custom-select').forEach(function (b) { if (!b.contains(e.target)) b.classList.remove('open'); }); });
    var rb = root.querySelector('.reset-btn');
    if (rb) rb.addEventListener('click', function () {
      sel.collections = 'all-collections'; sel.products = null; sel.cups = null;
      $$('.custom-select').forEach(function (box) {
        var s = box.querySelector('.selected'), type = box.querySelector('.dropdown-list').getAttribute('data-select');
        s.innerHTML = '<span>' + (s.getAttribute('data-placeholder') || 'Select') + '</span>';
        $$('li', box).forEach(function (li) { li.classList.remove(ACT, 'hide'); var r = li.querySelector('.radio-circle'); r && r.classList.remove(ACT); });
        var def = box.querySelector(type === 'collections' ? 'li[data-value="all-collections"]' : type === 'products' ? 'li[data-value="all-products"]' : 'li[data-value="all"]');
        if (def) { def.classList.add(ACT); var r = def.querySelector('.radio-circle'); r && r.classList.add(ACT); }
      });
      ['all-inserts', 'all-bras', 'all-tapes'].forEach(function (v) { var li = root.querySelector('li[data-value="' + v + '"]'); li && li.classList.add('hide'); });
      lockProducts(true);
    });
    var ac = root.querySelector('li[data-value="all-collections"]');
    if (ac && ac.classList.contains(ACT)) sel.collections = 'all-collections';
    showPage(); updateCups();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
